export const QUOTATION_STORAGE_KEY = "threepl_quotations";
export const QUOTATION_STORAGE_VERSION = 2;

export const QUOTATION_TAB = Object.freeze({
  customer: "customer",
  transporter: "transporter",
});

export const QUOTATION_DEFAULT_LIMIT = 8;
export const QUOTATION_LIMIT_OPTIONS = [8, 10, 20, 50];

export const generatedLoadQuotationTemplates = [
  {
    partyName: "Boxcar Logistics",
    pocName: "Bilal Khan",
    pocContact: "+92 322 7654321",
  },
  {
    partyName: "Wayfinder Cargo",
    pocName: "Ahmed Ali",
    pocContact: "+92 334 5678901",
  },
  {
    partyName: "Stellar Shipping",
    pocName: "Omar Farooq",
    pocContact: "+92 300 9956417",
  },
];

const sharedQuotationRows = [
  {
    loadId: "LDB-1001",
    partyName: "FuelOne Logistics Pvt. Ltd.",
    pocName: "Shahbaz Ali",
    pocContact: "+92 301 9876543",
    buyingPrice: 150000,
    quotationDate: "2025-10-18",
    loadingPoint: "Karachi Port Karachi...",
    loadQuotations: [
      {
        id: "LDB-1001-A",
        partyName: "Boxcar Logistics",
        pocName: "Bilal Khan",
        pocContact: "+92 322 7654321",
        buyingPrice: 150000,
        quotationDate: "2025-10-18",
        loadingPoint: "Gaddani Port Gaddani...",
      },
      {
        id: "LDB-1001-B",
        partyName: "Wayfinder Cargo",
        pocName: "Ahmed Ali",
        pocContact: "+92 334 5678901",
        buyingPrice: 160000,
        quotationDate: "2025-10-18",
        loadingPoint: "Gaddani Port Gaddani...",
      },
      {
        id: "LDB-1001-C",
        partyName: "Stellar Shipping",
        pocName: "Omar Farooq",
        pocContact: "+92 300 9956417",
        buyingPrice: 165000,
        quotationDate: "2025-10-18",
        loadingPoint: "Gaddani Port Gaddani...",
      },
    ],
  },
  {
    loadId: "LDB-1002",
    partyName: "AutoCare Solutions",
    pocName: "Khalid Hussain",
    pocContact: "+92 303 4455667",
    buyingPrice: 90000,
    quotationDate: "2025-09-30",
    loadingPoint: "Gaddani Port Gaddani...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1003",
    partyName: "BuildRight Hardware Mart",
    pocName: "Zeeshan Ahmed",
    pocContact: "+92 302 1122334",
    buyingPrice: 120000,
    quotationDate: "2025-09-30",
    loadingPoint: "Port of Pasni Pasni...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1004",
    partyName: "PakRoad Carriers",
    pocName: "Farhan Iqbal",
    pocContact: "+92 304 7788990",
    buyingPrice: 330000,
    quotationDate: "2025-09-30",
    loadingPoint: "Port of Gwadar Gwadar...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1005",
    partyName: "FreshNest Foods",
    pocName: "Imran Qureshi",
    pocContact: "+92 305 2233445",
    buyingPrice: 45000,
    quotationDate: "2025-07-15",
    loadingPoint: "Port of Keti Bandar Keti Bandar...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1006",
    partyName: "Nexon Builders & Co.",
    pocName: "Nadeem Akhtar",
    pocContact: "+92 306 6677889",
    buyingPrice: 150000,
    quotationDate: "2025-07-15",
    loadingPoint: "Port of Qasim Port Qasim...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1007",
    partyName: "AgroTrust Traders",
    pocName: "Rashid Mehmood",
    pocContact: "+92 307 3344556",
    buyingPrice: 225000,
    quotationDate: "2025-06-09",
    loadingPoint: "Port of Mukran Mukran...",
    loadQuotations: [],
  },
  {
    loadId: "LDB-1008",
    partyName: "MediCore Distributors",
    pocName: "Javed Anwar",
    pocContact: "+92 308 9988776",
    buyingPrice: 320000,
    quotationDate: "2025-02-08",
    loadingPoint: "Port of Ormara Ormara...",
    loadQuotations: [],
  },
];

const createTabRows = (prefix) =>
  sharedQuotationRows.map((row, index) => ({
    ...row,
    id: `${prefix}${1001 + index}`,
    loadQuotations: Array.isArray(row.loadQuotations)
      ? row.loadQuotations.map((item) => ({ ...item }))
      : [],
  }));

export const defaultQuotationRecords = {
  [QUOTATION_TAB.customer]: createTabRows("QCU-"),
  [QUOTATION_TAB.transporter]: createTabRows("QTR-"),
};
